<mat-card class="analyzing-card">
    <mat-card-content>
        <div class="analyzing-content">
            <!-- Header: Sparkle + Title -->
            <div class="analyzing-header">
                <div class="ai-sparkle">
                    <i class="ph-bold ph-sparkle icon-ai-purple icon-32 sparkle-icon" aria-hidden="true"></i>
                </div>
                <h2 class="analyzing-title">{{ customTitle || 'AI is analyzing your file...' }}</h2>
            </div>

            <!-- Timeline Steps -->
            <div class="timeline">
                <div class="timeline-item"
                     *ngFor="let message of messages; let i = index; let last = last; trackBy: trackByIndex"
                     [class.completed]="getMessageState(i) === 'completed'"
                     [class.active]="getMessageState(i) === 'active'"
                     [class.pending]="getMessageState(i) === 'pending'">

                    <div class="timeline-marker">
                        <div class="marker-outer">
                            <div class="marker-inner"></div>
                        </div>
                        <div class="marker-line" *ngIf="!last"></div>
                    </div>

                    <span class="timeline-text">{{ message }}</span>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
